import { useEffect } from "react";
// @mui
import { Box, Stack, Typography } from "@mui/material";
import { UseFormGetValues, UseFormSetValue } from "react-hook-form";
// styling
import styles from "src/components/UI/Profile/assets/scss/Profile.module.scss";

interface PersonalInfoDisplayProps {
  getValues: UseFormGetValues<{
    user_name: any;
    profession: any;
    first_name: any;
    last_name: any;
    email: any;
    bio: any;
    street: any;
    city: any;
    state: any;
    country: any;
    zip_code: any;
  }>;
}
const PersonalInfoDisplay = ({ getValues }: PersonalInfoDisplayProps) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Stack spacing={1} alignItems="flex-start" sx={{ p: 0 }}>
        <Box
          sx={{
            width: "100%",
          }}
          rowGap={1}
          columnGap={1}
          display="grid"
          gridTemplateColumns="repeat(2, minmax(1rem, 1fr))"
        >
          <div className={styles.detailsItem}>
            <Typography className={styles.detailsInfoHead} variant="subtitle2">
              First name
            </Typography>
            <Typography className={styles.detailsInfo} variant="subtitle2">
              {getValues("first_name")}
            </Typography>
          </div>
          <div className={styles.detailsItem}>
            <Typography className={styles.detailsInfoHead} variant="subtitle2">
              Last name
            </Typography>
            <Typography className={styles.detailsInfo} variant="subtitle2">
              {getValues("last_name")}
            </Typography>
          </div>
        </Box>
        <div className={styles.detailsItem}>
          <Typography className={styles.detailsInfoHead} variant="subtitle2">
            Email address
          </Typography>
          <Typography className={styles.detailsInfo} variant="subtitle2">
            {getValues("email")}
          </Typography>
        </div>
        <div
          className={`${styles.detailsItem} ${styles.case}`}
          style={{ maxWidth: "97.5vw" }}
        >
          <Typography className={styles.detailsInfoHead} variant="subtitle2">
            Bio
          </Typography>
          <Typography
            className={styles.detailsInfo}
            variant="subtitle2"
            style={{ fontSize: "0.85rem", whiteSpace: "pre-wrap" }}
          >
            {getValues("bio")}
          </Typography>
        </div>
      </Stack>
    </Box>
  );
};
export default PersonalInfoDisplay;
